export interface UnloadedFuelDataRecord {
    id: number;
    fuelReceiptsInternalId: number;
    departureAirportIATA: string;
    arrivalAirportIATA: string;
    flightNumber: string;
    date: string;
    aircraftRegistration: string;
    quantity: string;
    sourceType: string;
    loadTimestamp: string,
    fileName: string,
    resolved: boolean,
    resolvedOriginalValue: boolean
  }
